// @flow
import type { PictureType } from '../../../atoms/picture/react/Picture';

export const PRESETKEY = {
  COMPARE: 'compare',
  FAKTID: 'faktid',
};

export const ZNCODE = {
  NI: 'Niedersachsen',
  BW: 'Baden-Württemberg',
  BY: 'Bayern',
  BE: 'Berlin',
  BB: 'Brandenburg',
  HB: 'Bremen',
  HH: 'Hamburg',
  HE: 'Hessen',
  MV: 'Mecklenburg-Vorpommern',
  NW: 'Nordrhein-Westfalen',
  RP: 'Rheinland-Pfalz',
  SL: 'Saarland',
  SN: 'Sachsen',
  ST: 'Sachsen-Anhalt',
  SH: 'Schleswig-Holstein',
  TH: 'Thüringen',
};

export type Faktregion = {
  zncode: $Keys<typeof ZNCODE>,
  title: $Values<typeof ZNCODE>,
};

export type Link = {
  text: string,
  url: string,
};

export type Fakt = {
  amount: number | null,
  faktregion: Faktregion,
  link?: Link,
};

export type Time = {
  year: number,
  month: number,
};

export type Faktrelease = {
  id: number,
  time: Time,
  source?: Link,
  fakt: Fakt[],
  averagevalue: number,
};

export type NumberFormat = {
  unit: string,
  decimals: number,
  decpoint: string,
  thousandssep?: string,
};

export type Topic = {
  title: string,
  topicexplanation?: string,
  format: NumberFormat,
  link: Link,
  faktrelease: Faktrelease[],
  orderascending?: boolean,
};

export type TopicTeaser = {
  subtitle: string,
  title: string,
  link: Link,
  image: PictureType & { copyright: string },
};

export type Tab = {
  tabtitle: string,
  topicdatas: Topic[],
  teasers: TopicTeaser[],
  teasersheadline?: string,
};

export type Data = {
  tabs: Tab[],
  defaultFaktrelease?: number,
};
